import React from 'react';
import RiskFingerprint from '../RiskFingerprint/RiskFingerprint';
import TrustWidget from '../TrustWidget/TrustWidget';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import './MainComponent.less';

class MainComponent extends React.Component {
    static propTypes = {
        handleDeviceList: PropTypes.func.isRequired
    };

    static get defaultProps() {
        return {
            handleDeviceList: () => {
            }
        };
    }

    state = {
        orgId: '0oammhpj',
        deviceId: uuid.v4()
    };

    handleTrustPayload = (trustPayload) => {
        const devices = [
            {type: 'THREAT_METRIX', deviceId: this.state.deviceId}
        ];
        if (trustPayload !== null) {
            devices.push({type: 'EXPEDIA_RISK_SERVICE', deviceId: trustPayload});
        }
        this.props.handleDeviceList(devices);
    };

    render() {
        const {orgId, deviceId} = this.state;
        return (
            <div className={'RiskComponent'}>
                <RiskFingerprint orgId={orgId} deviceId={deviceId}/>
                <TrustWidget handlePayload={this.handleTrustPayload}/>
            </div>
        );
    }
}

export default MainComponent;
